import type { TreeTag } from '#domains/tags';
import {
  filterByQuery,
  filterDuplicates,
  filterHiddenChildren
} from './filters';

type Args = {
  tags: TreeTag[];
  expanded?: boolean;
  queryString: string;
};

export const searchTreeTags = ({
  tags,
  expanded = true,
  queryString
}: Args) => {
  if (queryString) {
    tags = filterByQuery(tags, queryString);
  }

  if (!expanded) {
    tags = filterHiddenChildren(tags);
  }

  return filterDuplicates(tags);
};
